import { gql } from '@apollo/client';

/**
 * Mutation to publish data for a given user
 * @param {String} userId - Optional user identifier
 * @returns Result of the publish operation
 */

export default gql`
  mutation createPublishData($userId: String) {
    publish(userId: $userId)
  }
`;
